import { getSubmitVerificationInformationCTA } from "./shared";
export var VerificationStatusIA = function VerificationStatusIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getSubmitVerificatio;
        return (_getSubmitVerificatio = getSubmitVerificationInformationCTA(context, strictLocalize)) === null || _getSubmitVerificatio === void 0 ? void 0 : _getSubmitVerificatio.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getSubmitVerificatio2, _getSubmitVerificatio3;
        return (_getSubmitVerificatio2 = getSubmitVerificationInformationCTA(context, strictLocalize)) === null || _getSubmitVerificatio2 === void 0 ? void 0 : (_getSubmitVerificatio3 = _getSubmitVerificatio2.getLink) === null || _getSubmitVerificatio3 === void 0 ? void 0 : _getSubmitVerificatio3.call(_getSubmitVerificatio2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return VERIFICATION_STATUS_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [VERIFICATION_STATUS_DESCRIPTION_1(strictLocalize), VERIFICATION_STATUS_DESCRIPTION_2(strictLocalize)];
    }
  };
};
var VERIFICATION_STATUS_TITLE = function VERIFICATION_STATUS_TITLE(strictLocalize) {
  return strictLocalize({
    id: "35Lofj",
    defaultMessage: [{
      "type": 0,
      "value": "Statut de vérification du compte"
    }]
  });
};
var VERIFICATION_STATUS_DESCRIPTION_1 = function VERIFICATION_STATUS_DESCRIPTION_1(strictLocalize) {
  return strictLocalize({
    id: "ipZPfy",
    defaultMessage: [{
      "type": 0,
      "value": "Si vous avez fourni toutes les informations requises, comptez 2 à 3 jours ouvrés pour que notre équipe les vérifie."
    }]
  });
};
var VERIFICATION_STATUS_DESCRIPTION_2 = function VERIFICATION_STATUS_DESCRIPTION_2(strictLocalize) {
  return strictLocalize({
    id: "RYBEPP",
    defaultMessage: [{
      "type": 0,
      "value": "Pour envoyer des informations supplémentaires, contactez-nous."
    }]
  });
};